module["exports"] = ["Øvre", "Nedre", "Søndre", "Gamle", "Østre", "Vestre"];